"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupProfile = setupProfile;

var _jQuery = babelHelpers.interopRequireDefault(require("jQuery"));

var _userProfile = require("user-profile");

function setupProfile() {
  var updateProfile = function updateProfile(profile) {
    var name;
    if (profile.photo && profile.photo.name) name = profile.photo.name;
    name = name || profile.defaultPhoto;
    (0, _jQuery.default)('.img-icon-user img').attr('src', "/t/width=1/height=1/cover/width=30/height=30/matte=none/scale/f".concat(name, "/user-photo.png"));
    (0, _jQuery.default)('.user-img img').attr('src', "/t/width=1/height=1/cover/width=200/height=200/matte=none/scale/f".concat(name, "/user-photo.png"));
    (0, _jQuery.default)('.user-img ~ .name, .img-icon-user ~ .name').text(profile.nickname || "".concat(profile.fullName));
  };

  (0, _jQuery.default)(document).on('profileUpdated', function (_ref) {
    var profile = _ref.profile;
    return updateProfile(profile);
  });
  (0, _userProfile.getUserProfile)().then(updateProfile);
}